// Trailing Chat cell for MobileBottomTabBar — opens shell messenger fullscreen.
import { useWorkplaceStreamChatSession } from "@/contexts/WorkplaceStreamChatSessionContext";
import { dispatchMessengerOpen } from "@/components/shell/popovers/messengerOpenEvent";
import { setMessengerSizeMode } from "@/lib/messages/messengerSizePreference";

export function MobileMessengerTabButton() {
  const session = useWorkplaceStreamChatSession();
  const unread = session.unreadCount;
  const hasUnread = unread > 0;
  const label = hasUnread ? `Messages, ${unread} unread` : "Messages";

  if (session.vendorEnabled === false) return null;

  return (
    <li className="w-14 flex-shrink-0">
      <button
        type="button"
        onClick={() => {
          setMessengerSizeMode("expanded");
          dispatchMessengerOpen({ force: true });
        }}
        aria-label={label}
        title={label}
        className={[
          "flex w-full flex-col items-center justify-center gap-1 px-1 py-1.5 text-[11px] transition-colors",
          hasUnread
            ? "text-teal-700 dark:text-teal-200"
            : "text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-100",
        ].join(" ")}
      >
        <span
          className={[
            "relative flex h-7 w-7 items-center justify-center rounded-lg text-[12px] font-semibold",
            hasUnread
              ? "bg-teal-600 text-white"
              : "bg-teal-50 text-teal-800 dark:bg-teal-950/50 dark:text-teal-200",
          ].join(" ")}
        >
          <span aria-hidden>{hasUnread ? "💬" : "✉"}</span>
          {hasUnread ? (
            <span className="absolute -right-1 -top-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-red-600 px-0.5 text-[9px] font-bold text-white">
              {unread > 9 ? "9+" : unread}
            </span>
          ) : null}
        </span>
        <span className="block w-full truncate text-center leading-tight">Chat</span>
      </button>
    </li>
  );
}
